import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react';

import { useDependencies, provide } from '@servicetitan/react-ioc';

import { WidgetContainer } from './components/widget-container/widget-container';

import { AnalyticsStore } from './stores/analytics.store';
import { WidgetStore } from './stores/widget.store';

import { WidgetData } from './api/widget-data.api';

import { Device } from './enums/device';

import './styles/app.css';

export const App: FC = provide({
    singletons: [WidgetStore, WidgetData, AnalyticsStore],
})(
    observer(() => {
        const [{ setPageSizes, isLoading, setDevice, device, init }] = useDependencies(WidgetStore);

        useEffect(init, [init]);

        useEffect(() => {
            window.addEventListener('message', ({ data }) => {
                if (data?.type === 'setSize') {
                    const { height, width } = data;
                    // TODO: later will be checked by device not by height/width
                    const isMobile = width <= 760 || height <= 600;

                    setPageSizes({ width, height });

                    if (isMobile) {
                        setDevice(Device.Mobile);
                    } else {
                        setDevice(Device.Desktop);
                    }
                }
            });
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        if (device === undefined || isLoading) {
            return null;
        }

        return (
            <React.StrictMode>
                <WidgetContainer />
            </React.StrictMode>
        );
    })
);
